import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { InfoBox } from "./Controls/InfoBox";

export interface AddSpacesTimingModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: (option: "immediate" | "next_cycle") => void;
}

export function AddSpacesModal({
  show,
  onClose,
  onConfirm,
}: AddSpacesTimingModalProps) {
  const [selected, setSelected] = useState<"immediate" | "next_cycle" | null>(null);

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add spaces now or later?</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Check
            type="radio"
            id="apply-immediately"
            name="applyOption"
            label={
              <>
                <strong>Add Immediately</strong> — Add spaces now.
              </>
            }
            value="immediate"
            checked={selected === "immediate"}
            onChange={() => setSelected("immediate")}
            className="mb-3"
          />

          <Form.Check
            type="radio"
            id="next-billing-cycle"
            name="applyOption"
            label={
              <>
                <strong>Next Billing Cycle</strong> — Add spaces starting with
                your next renewal cycle.
              </>
            }
            value="next_cycle"
            checked={selected === "next_cycle"}
            onChange={() => setSelected("next_cycle")}
          />
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          disabled={!selected}
          onClick={() => selected && onConfirm(selected)}
        >
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
}